/**
 * 下载图片（普通图片url / blob图片地址通用）
 * @param {String} imgSrc 图片网络地址 / blob地址
 * @param {String} fileName 保存图片名称（如：海报.png）
 * @param {Vue} vm 组件this，用于element提示
 */
export function downloadImage(imgSrc, fileName, vm) {
    // 处理blob临时图片链接
    if (/^blob:/.test(imgSrc)) {
        const a = document.createElement('a')
        a.href = imgSrc
        a.download = fileName
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        return
    }

    // 普通http图片地址，用XHR转blob下载（解决浏览器图片直接预览不下载、跨域问题）
    const xhr = new XMLHttpRequest()
    // 时间戳清除缓存
    const url = `${imgSrc}?t=${Date.now()}`
    xhr.open('GET', url, true)
    xhr.responseType = 'blob'

    xhr.onload = () => {
        if (xhr.status === 200) {
            const blob = xhr.response
            const blobUrl = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = blobUrl
            a.download = fileName
            document.body.appendChild(a)
            a.click()
            // 释放资源，防止内存溢出
            document.body.removeChild(a)
            window.URL.revokeObjectURL(blobUrl)
        } else {
            const tip = `图片下载失败，状态码：${xhr.status}`
            vm ? vm.$message.error(tip) : console.error(tip)
        }
    }

    xhr.onerror = () => {
        const tip = '图片加载失败，地址无效或存在跨域限制'
        vm ? vm.$message.error(tip) : console.error(tip)
    }

    xhr.send()
}